/**
 * Info Actions
 *
 * Actions for viewing object information and properties.
 */

import { Info } from 'lucide-react';
import type { ObjectActionDefinition, ObjectActionContext } from '../types';
import { toast } from '../../../../components/ui/toaster';

/**
 * Properties action - shows object properties
 *
 * Note: This is a placeholder that shows a toast. In a future slice,
 * this will open a properties panel or dialog.
 */
export const propertiesAction: ObjectActionDefinition = {
  id: 'properties',
  label: 'Properties',
  icon: Info,
  category: 'info',
  appliesTo: ['table', 'view', 'procedure', 'function'],
  execute: (context: ObjectActionContext) => {
    // TODO: Implement properties panel in future slice
    toast.default({
      title: 'Properties',
      description: `${context.objectType}: ${context.schemaName}.${context.objectName}`,
    });
  },
};

/**
 * All info actions
 */
export const infoActions: ObjectActionDefinition[] = [
  propertiesAction,
];
